const isEmptyField = (fieldValue) => !fieldValue || fieldValue?.trim().length < 2;

export const defaultValidator = (shipToAddress) => {
  const { name, line1, city } = shipToAddress;
  const fieldErrorHash = {
    name: isEmptyField(name),
    line1: isEmptyField(line1),
    city: isEmptyField(city),
    postalCode: false,
    state: false,
  };
  return {
    countryCode: '',
    fieldErrorHash,
    requiresName: true,
    requiresLine1: true,
    requiresCity: true,
    requiresPostalCode: false,
    requiresState: false,
  };
};

const US = (shipToAddress) => {
  const defaultValidation = defaultValidator(shipToAddress);
  const fieldErrorHash = {
    ...defaultValidation.fieldErrorHash,
    state: isEmptyField(shipToAddress.state),
    postalCode: isEmptyField(shipToAddress.postalCode),
  };
  return {
    ...defaultValidation,
    countryCode: 'US',
    fieldErrorHash,
    requiresPostalCode: true,
    requiresState: true,
  };
};

const CA = (shipToAddress) => {
  const defaultValidation = defaultValidator(shipToAddress);
  const fieldErrorHash = {
    ...defaultValidation.fieldErrorHash,
    state: isEmptyField(shipToAddress.state),
    postalCode: isEmptyField(shipToAddress.postalCode),
  };
  return {
    ...defaultValidator,
    countryCode: 'CA',
    fieldErrorHash,
    requiresPostalCode: true,
    requiresState: true,
  };
};

export const countryValidatorsService = {
  US,
  CA,
};
